/**
 * Internal dependencies
 */
import { getCookie, setCookie } from '../utils/cookies';

export function getAlternative( settings ) {
	const { maxCombinations } = settings;
	let alternative = Number.parseInt( getCookie( 'nabAlternative' ) );
	if (
		isNaN( alternative ) ||
		alternative < 0 ||
		alternative >= maxCombinations
	) {
		alternative = random( maxCombinations - 1 );
		setCookie( 'nabAlternative', alternative, { expires: 120 } );
		setCookie( 'nabExperimentsWithPageViews', '{}', { expires: 120 } );
	} //end if

	if ( shouldAlternativeBeOverwritten( alternative ) ) {
		alternative = getAlternativeValueFromQueryArgs();
		setCookie( 'nabAlternative', alternative, { expires: 120 } );
		setCookie( 'nabExperimentsWithPageViews', '{}', { expires: 120 } );
	} //end if

	setCookie( 'nabAlternative', getCookie( 'nabAlternative' ), {
		expires: 120,
	} );
	setCookie(
		'nabExperimentsWithPageViews',
		getCookie( 'nabExperimentsWithPageViews' ),
		{ expires: 120 }
	);

	return alternative;
} //end getAlternative()

function random( max ) {
	return Math.min( Math.floor( Math.random() * ( max + 1 ) ), max );
} //end random()

function shouldAlternativeBeOverwritten( assignedAlternative ) {
	const search = document.location.search;
	if ( ! /\bnabforce\b/.test( search ) ) {
		return false;
	} //end if

	if ( ! /\bnab\b=[0-9]+/.test( search ) ) {
		return false;
	} //end if

	const expectedAlternative = getAlternativeValueFromQueryArgs();
	return expectedAlternative !== assignedAlternative;
} //end shouldAlternativeBeOverwritten()

function getAlternativeValueFromQueryArgs() {
	const search = document.location.search;
	return Number.parseInt( search.replace( /^.*\bnab\b=([0-9]+).*$/, '$1' ) );
} //end getAlternativeValueFromQueryArgs()
